import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'C# Application Development (Desktop and Game)',
                topics: [
                    'Game development with Unity and C#',
                    'Building cross-platform desktop applications with C# and .NET Core',
                    'Developing desktop apps with Windows Presentation Foundation (WPF) and C#',
                ],
            },
            {
                title: 'C# Application Development (Web and Cloud)',
                topics: [
                    'Developing cross-platform mobile apps with Xamarin and C#',
                    'Developing scalable and secure cloud-native applications with C# and Kubernetes',
                    'Developing high-performance web applications with C#',
                    'Building microservices with C# and http://ASP.NET/ Core',
                    'Building RESTful APIs with C# and http://ASP.NET/ Core',
                    'Developing serverless applications with Azure Functions and C#',
                ],
            },
            {
                title: 'Advanced C#',
                topics: [
                    'Implementing authentication and authorization in C# applications',
                    'Building machine learning models with C# and ML.NET',
                    'Using C# for blockchain development',
                    'Exploring the latest features in C# 10 and .NET 6',
                    'Reactive programming with C# and Reactive Extensions (Rx)',
                ],
            },
            {
                title: 'Advanced C#',
                topics: [
                    'Implementing multithreading in C#: challenges and best practices',
                    'Best practices for error handling in C# applications',
                    'Test-driven development (TDD) with C#: benefits and best practices',
                    'Leveraging LINQ for data querying and manipulation in C#',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What is the event about?</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;